import { environment } from '~env/environment';
import {
  BUYER_EXTERNAL_MARKET_LINK,
  BUYER_EXTERNAL_DELIVERY_LINK,
  BUYER_EXTERNAL_SERVICE_LINK,
  BUYER_EXTERNAL_SERVICE_LINK_ES,
  BUYER_EXTERNAL_DELIVERY_LINK_ES,
  BUYER_EXTERNAL_MARKET_LINK_ES,
  BUYER_EXTERNAL_SERVICE_LINK_IT,
  BUYER_EXTERNAL_DELIVERY_LINK_IT,
  BUYER_EXTERNAL_MARKET_LINK_IT,
  BUYER_EXTERNAL_SERVICE_LINK_PT,
  BUYER_EXTERNAL_DELIVERY_LINK_PT,
  BUYER_EXTERNAL_MARKET_LINK_PT,
  BUYER_EXTERNAL_MARKET_LINK_NL,
  BUYER_EXTERNAL_DELIVERY_LINK_NL,
  BUYER_EXTERNAL_SERVICE_LINK_NL,
  BUYER_EXTERNAL_MARKET_LINK_FR,
  BUYER_EXTERNAL_DELIVERY_LINK_FR,
  BUYER_EXTERNAL_SERVICE_LINK_FR
} from '~shared/constants/links.constants';
import {
  TOP_LINKS_DELIVERY_ICON,
  TOP_LINKS_INFO_ICON,
  TOP_LINKS_MY_MARKET_ICON,
  TOP_LINKS_ONLINE_SHOP_ICON
} from '~shared/constants/icons.constant';

const id1 = 'external_link_1';
const id2 = 'external_link_2';
const id3 = 'external_link_3';
const id4 = 'external_link_4';
const buttonText1 = 'CORE.ALL_PAGES.HEADER_TOPBUCKET.BUTTON1.TEXT';
const buttonText2 = 'CORE.ALL_PAGES.HEADER_TOPBUCKET.BUTTON2.TEXT';
const buttonText3 = 'CORE.ALL_PAGES.HEADER_TOPBUCKET.BUTTON3.TEXT';
const buttonText4 = 'CORE.ALL_PAGES.HEADER_TOPBUCKET.BUTTON4.TEXT';
const onlineShopLabel = 'OnlineShop';
const myMarketLabel = 'MyStoreBucket';
const deliveryLabel = 'DeliveryBucket';
const infoLabel = 'InfosAndServicesBucket';

export const MENU_EXTERNAL_LINKS = () => ({
  de: {
    external_link_1: {
      id: id1,
      title: buttonText1,
      icon: TOP_LINKS_ONLINE_SHOP_ICON(),
      link: environment.baseHref(),
      active: true,
      trackingLabel: onlineShopLabel,
      showMobile: false,
      width: 160,
    },
    external_link_2: {
      id: id2,
      title: buttonText2,
      icon: TOP_LINKS_MY_MARKET_ICON(),
      link: BUYER_EXTERNAL_MARKET_LINK,
      active: false,
      trackingLabel: myMarketLabel,
      showMobile: true,
      width: 160,
    },
    external_link_3: {
      id: id3,
      title: buttonText3,
      icon: TOP_LINKS_DELIVERY_ICON(),
      link: BUYER_EXTERNAL_DELIVERY_LINK,
      active: false,
      trackingLabel: deliveryLabel,
      showMobile: true,
      width: 266,
    },
    external_link_4: {
      id: id4,
      title: buttonText4,
      icon: TOP_LINKS_INFO_ICON(),
      link: BUYER_EXTERNAL_SERVICE_LINK,
      active: false,
      trackingLabel: infoLabel,
      showMobile: true,
      width: 190,
    },
  },
  es: {
    external_link_1: {
      id: id1,
      title: buttonText1,
      icon: TOP_LINKS_ONLINE_SHOP_ICON(),
      link: environment.baseHref(),
      active: true,
      trackingLabel: onlineShopLabel,
      showMobile: false,
      width: 217
    },
    external_link_2: {
      id: id2,
      title: buttonText3,
      icon: TOP_LINKS_DELIVERY_ICON(),
      link: BUYER_EXTERNAL_DELIVERY_LINK_ES,
      active: false,
      trackingLabel: deliveryLabel,
      showMobile: true,
      width: 242
    },
    external_link_3: {
      id: id3,
      title: buttonText2,
      icon: TOP_LINKS_MY_MARKET_ICON(),
      link: BUYER_EXTERNAL_MARKET_LINK_ES,
      active: false,
      trackingLabel: myMarketLabel,
      showMobile: true,
      width: 145
    },
    external_link_4: {
      id: id4,
      title: buttonText4,
      icon: TOP_LINKS_INFO_ICON(),
      link: BUYER_EXTERNAL_SERVICE_LINK_ES,
      active: false,
      trackingLabel: infoLabel,
      showMobile: true,
      width: 190
    }
  },
  it: {
    external_link_1: {
      id: id1,
      title: buttonText1,
      icon: TOP_LINKS_ONLINE_SHOP_ICON(),
      link: environment.baseHref(),
      active: true,
      trackingLabel: onlineShopLabel,
      showMobile: false,
      width: 190,
    },
    external_link_2: {
      id: id2,
      title: buttonText2,
      icon: TOP_LINKS_MY_MARKET_ICON(),
      link: BUYER_EXTERNAL_MARKET_LINK_IT,
      active: false,
      trackingLabel: myMarketLabel,
      showMobile: true,
      width: 180,
    },
    external_link_3: {
      id: id3,
      title: buttonText3,
      icon: TOP_LINKS_DELIVERY_ICON(),
      link: BUYER_EXTERNAL_DELIVERY_LINK_IT,
      active: false,
      trackingLabel: deliveryLabel,
      showMobile: true,
      width: 203,
    },
    external_link_4: {
      id: id4,
      title: buttonText4,
      icon: TOP_LINKS_INFO_ICON(),
      link: BUYER_EXTERNAL_SERVICE_LINK_IT,
      active: false,
      trackingLabel: infoLabel,
      showMobile: true,
      width: 181,
    },
  },
  pt: {
    external_link_1: {
      id: id1,
      title: buttonText1,
      icon: TOP_LINKS_ONLINE_SHOP_ICON(),
      link: environment.baseHref(),
      active: true,
      trackingLabel: onlineShopLabel,
      showMobile: false,
      width: 160,
    },
    external_link_2: {
      id: id2,
      title: buttonText2,
      icon: TOP_LINKS_MY_MARKET_ICON(),
      link: BUYER_EXTERNAL_MARKET_LINK_PT,
      active: false,
      trackingLabel: myMarketLabel,
      showMobile: true,
      width: 243,
    },
    external_link_3: {
      id: id3,
      title: buttonText3,
      icon: TOP_LINKS_DELIVERY_ICON(),
      link: BUYER_EXTERNAL_DELIVERY_LINK_PT,
      active: false,
      trackingLabel: deliveryLabel,
      showMobile: true,
      width: 217,
    },
    external_link_4: {
      id: id4,
      title: buttonText4,
      icon: TOP_LINKS_INFO_ICON(),
      link: BUYER_EXTERNAL_SERVICE_LINK_PT,
      active: false,
      trackingLabel: infoLabel,
      showMobile: true,
      width: 185,
    },
  },
  nl: {
    external_link_1: {
      id: id1,
      title: buttonText1,
      icon: TOP_LINKS_ONLINE_SHOP_ICON(),
      link: environment.baseHref(),
      active: true,
      trackingLabel: onlineShopLabel,
      showMobile: false,
      width: 150,
    },
    external_link_2: {
      id: id2,
      title: buttonText2,
      icon: TOP_LINKS_MY_MARKET_ICON(),
      link: BUYER_EXTERNAL_MARKET_LINK_NL,
      active: false,
      trackingLabel: myMarketLabel,
      showMobile: true,
      width: 227,
    },
    external_link_3: {
      id: id3,
      title: buttonText3,
      icon: TOP_LINKS_DELIVERY_ICON(),
      link: BUYER_EXTERNAL_DELIVERY_LINK_NL,
      active: false,
      trackingLabel: deliveryLabel,
      showMobile: true,
      width: 248,
    },
    external_link_4: {
      id: id3,
      title: buttonText4,
      icon: TOP_LINKS_INFO_ICON(),
      link: BUYER_EXTERNAL_SERVICE_LINK_NL,
      active: false,
      trackingLabel: infoLabel,
      showMobile: true,
      width: 244,
    },
  },
  fr: {
    external_link_1: {
      id: id1,
      title: buttonText1,
      icon: TOP_LINKS_ONLINE_SHOP_ICON(),
      link: environment.baseHref(),
      active: true,
      trackingLabel: onlineShopLabel,
      showMobile: false,
      width: 164,
    },
    external_link_2: {
      id: id2,
      title: buttonText2,
      icon: TOP_LINKS_MY_MARKET_ICON(),
      link: BUYER_EXTERNAL_MARKET_LINK_FR,
      active: false,
      trackingLabel: myMarketLabel,
      showMobile: true,
      width: 248,
    },
    external_link_3: {
      id: id3,
      title: buttonText3,
      icon: TOP_LINKS_DELIVERY_ICON(),
      link: BUYER_EXTERNAL_DELIVERY_LINK_FR,
      active: false,
      trackingLabel: deliveryLabel,
      showMobile: true,
      width: 200,
    },
    external_link_4: {
      id: id4,
      title: buttonText4,
      icon: TOP_LINKS_INFO_ICON(),
      link: BUYER_EXTERNAL_SERVICE_LINK_FR,
      active: false,
      trackingLabel: infoLabel,
      showMobile: true,
      width: 198,
    },
  },
});
